import Util from '../../util/Util';
import SingleZone from './SingleZone';


const FCCZone = {

  /**
     *
     *
     * @param data = Fcc recommendation response
     * data = {
     *      products:{
     *        navigationPoolProducts:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]
     *      }
     *  }
     * @param params = {
     *  maxRecommendations : 15,
     *
     * }
     * @returns {*} = {
     *  status: 'SUCCESS',
     *  error: null,
     *  recommendedItems:[recommendationItem]
     * }
     *
     * This method generates a choiceId with
     * hardcoded controlGroupId cidM01MBN,
     * header H7 customers+also+shopped
     * format : `cidM01MBN-${Util.uuid()}@H7@customers+also+shopped$${params.categoryId}$`
     *
     * It maps all the navigationPoolProducts to following structure:
     * recommendationItem = {
     *  choiceId: <above generated choiceId>
     *  recommendedItemId: <productId from navigationPoolProducts>
     *  productId: <same as recommendedItemId>
     * }
     *
     */
  convertToRecommendationResponse(data, params) {
    if (!data || !data.products || !data.products.navigationPoolProducts || !params) {
      return false;
    }
    const recommendationResponse = {
      status: 'SUCCESS',
      error: null,
    };
    const choiceId = `cidM01MBN-${Util.uuid()}@H7@customers+also+shopped$${params.categoryId}$`;

    const recommendedProducts = data.products.navigationPoolProducts.length > params.maxRecommendations ?
      data.products.navigationPoolProducts.slice(0, params.maxRecommendations) : data.products.navigationPoolProducts;

    recommendationResponse.recommendedItems = recommendedProducts.map(productId => ({
      choiceId: choiceId + productId,
      recommendedItemId: productId,
      productId,
    }));

    return recommendationResponse;
  },

  recommendation(fccResponse, opts) {
    if (!fccResponse || !opts || !opts.zone) { return undefined; }

    const recommendationResponse = this.convertToRecommendationResponse(fccResponse, opts);
    const recommendedItems = SingleZone.recommendation(recommendationResponse);
    return {
      recommendedItems,
      recommendationsOnAllZones: {},
      zone: Util.fallbackZone(opts.zone),
    };
  },

};


export default FCCZone;
